import { render, staticRenderFns } from "./AlgorithmValueNotice.vue?vue&type=template&id=09ba5cd2&scoped=true"
import script from "./AlgorithmValueNotice.vue?vue&type=script&lang=js"
export * from "./AlgorithmValueNotice.vue?vue&type=script&lang=js"
import style0 from "./AlgorithmValueNotice.vue?vue&type=style&index=0&id=09ba5cd2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ba5cd2",
  null
  
)

export default component.exports